export const HUBSPOT_DEFINED_OUTPUT_PREFIX = 'hs_';
export const EXECUTION_STATE_OUTPUT = 'hs_execution_state';
export const STATUS_CODE = 'hs_status_code';
export const SERVER_RESPONSE = 'hs_server_response';